import { render, staticRenderFns } from "./InterventionsList.vue?vue&type=template&id=af4478a4"
import script from "./InterventionsList.vue?vue&type=script&lang=js"
export * from "./InterventionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports